<template>
  <div class="mt-3">
    <SearchCard v-for="(gemeo, index) in gemeos"
                :key="index"
                class="mb-3"
                :check="gemeo.check"
                :data-info="gemeo" />
  </div>
</template>
<script>
  /** components */
  import SearchCard from "@/components/SofiaRei/Busca/SearchCard"

  /* services */
  import NascimentoService from "@/services/Registros/Nascimento"

  /** utils */
  import { transformSearchedRascunho } from '@/utils/itemRascunho'

  export default {
    name: 'ResumoGemeos',
    components: {
      SearchCard
    },
    props: {
      propData: {type: Object, default: () => ({})},
      propGerados: {type: Array, default: () => ([])}
    },
    data () {
      return {
        gemeos: [],
        data: {}
      }
    },
    watch: {
      propData () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        try {
          loader({ active: true, text: 'Carregando gemeos' })
          if (this.data.nascimento_id === this.propData.nascimento_id) return

          this.data = this.propData
          this.gemeos = []

          if (this.data.registro) {
            await this.getGemeos()
          }
        } finally {
          loader({ active: false })
        }
      },
      async getGemeos () {
        this.gemeos = []

        const { gemeos } = this.data.registro.pessoa

        if (!gemeos || !gemeos.length) return

        for (const gemeo of gemeos) {
          try {
            if (gemeo.matricula) {
              const nascimento = await NascimentoService.getNascimentoByMatricula(gemeo.matricula)

              if (nascimento) {
                const data = await NascimentoService.getNascimentoById(nascimento.nascimento_id)

                if (data) {
                  const objRegistro = {
                    ...data.registro,
                    nascimento: data
                  }

                  this.gemeos.push(objRegistro)
                }
              }
            } else if (gemeo.rascunho_id) {
              const rascunho = await NascimentoService.getNascimentoRascById(gemeo.rascunho_id)

              if (rascunho) {
                this.gemeos.push(transformSearchedRascunho(rascunho))
              }
            }
          } catch (error) {
            console.error(error)

            continue
          }
        }
      }
    }
  }
</script>
